import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import {cn} from '../lib/cn';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({className, ...props}, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn('relative flex w-full touch-none select-none items-center', className)}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-[var(--slider-track-bg)]">
      <SliderPrimitive.Range className="absolute h-full bg-[var(--slider-range-bg)]" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="block h-4 w-4 rounded-full border cursor-pointer border-[var(--slider-thumb-border)] bg-[var(--slider-thumb-bg)] shadow transition-all hover:brightness-110 hover:scale-105 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[var(--slider-focus-ring)] disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
));

Slider.displayName = SliderPrimitive.Root.displayName;

export {Slider};
